angular.module('impactx.tinymce').service("TinyMceHelperService", TinyMceHelperService);

TinyMceHelperService.$inject = ['dataGen', '$rootScope', 'FileHelperService', 'LoadingDialogService', '$timeout'];

function TinyMceHelperService(dataGen, $rootScope, FileHelperService, LoadingDialogService, $timeout) {
    var self = this;

    var getConfigurationWithUpload = function (baseConfig) {
        var config = JSON.parse(JSON.stringify(baseConfig));
        config.file_browser_callback_types = 'image';
        config.file_browser_callback = function (fieldName, url, type, win) {
            var input = document.createElement('input');
            input.setAttribute('type', 'file');
            input.setAttribute('accept', 'image/*');
            input.addEventListener('change', function (evt) {
                self.handleFileSelect(evt, fieldName);
            });
            input.click();
        };
        return config;
    };

    this.handleFileSelect = function (evt, fieldName)
    {
        var file = evt.currentTarget.files[0];
        $(this).val("");
        self.handleFile(evt, file, fieldName);
    };

    this.handleFile = function(evt, file, fieldName)
    {
        if (file) {
            if (!FileHelperService.checkAllowedFileWithError(file.name)) {
                return;
            }
            $rootScope.$evalAsync(function () {
                self.addAttachmentStream(file, fieldName);
            });
        }
    };

    this.addAttachmentStream = function (file, fieldName) {
        var data = {
            file: file,
            fileName: file.name
        };
        LoadingDialogService.start();
        dataGen.uploadFile(data, '/upload/tinymce/add').then(function (response) {
            LoadingDialogService.stop();
            document.getElementById(fieldName).value = response.data.url;
        }, function () {
            LoadingDialogService.stop();
        });
    };

    return {
        getConfigurationWithUpload: getConfigurationWithUpload
    };
}